module.exports = __webpack_public_path__ + "img/8712e53249ea79ec5411c6f23b76a9bf.png";